
import moment from "moment-timezone";
import { logger } from "../Logger.js";

export function getDiffMinsAccordingByStoreTimeZone(storeDoc, scheduledTime, _storeLocDate) {

  let storeLocDate = moment(_storeLocDate);

  let storeZone = "";
  let storeDate = "", OrderDate = "";

  if (storeDoc && storeDoc.TimezoneIanaFormat) {
    try {
      storeZone = (storeDoc.TimezoneIanaFormat || "").trim();
      if (!moment.tz.zone(storeZone))
        throw new Error(storeZone + " is an invalid time zone.");
      else {
        storeDate = moment.tz(storeLocDate, storeZone).format();
        //storeLocDate = moment.tz(storeLocDate, storeZone);
        storeLocDate = moment(storeDate);

        if (scheduledTime) {
          let scheduleDate = moment.utc(scheduledTime.toDate());

          OrderDate = moment.tz(scheduleDate, storeZone).format();
          //scheduleDate = moment.tz(scheduleDate, storeZone);
          scheduleDate = moment(OrderDate);

          var duration = moment.duration(scheduleDate.diff(storeLocDate));
          var minutes = duration.asMinutes();
          //let diff = ((new Date(OrderDate)) - (new Date(storeDate)));
          return Math.round(minutes);

        }
      }
    }
    catch (e) {
      logger.log(
        "error",
        e.message,
        "getDiffMinsAccordingByStoreTimeZone",
        logger.LogType.Error
      );
    }
  }

  return 0;
}

export function getDateTimeAccordingToStoreTimeZone(storeDoc, orginDatetime, _storeLocDate) {

  let storeLocDate = moment(_storeLocDate);
  let storeZone = "";
  let storeDate = "", OrderDate = "";

  if (storeDoc && storeDoc.TimezoneIanaFormat) {
    try {
      storeZone = (storeDoc.TimezoneIanaFormat || "").trim();
      if (!moment.tz.zone(storeZone))
        throw new Error(storeZone + " is an invalid time zone.");
      else {
        storeDate = moment.tz(storeLocDate, storeZone).format();

        storeLocDate = moment(storeDate);

        if (orginDatetime) {
          let scheduleDate = moment.utc(orginDatetime.toDate());

          OrderDate = moment.tz(scheduleDate, storeZone).format();

          scheduleDate = moment(OrderDate);

          var duration = moment.duration(scheduleDate.diff(storeLocDate));
          var minutes = duration.asMinutes();

          return Math.round(minutes);

        }
      }
    }
    catch (e) {
      logger.log(
        "error",
        e.message,
        "getDateTimeAccordingToStoreTimeZone",
        logger.LogType.Error
      );
    }
  }

  return 0;
}

export function getCurrentStoreDateTime(storeDoc, _storeLocDate) {

  let storeLocDate = moment(_storeLocDate);
  let storeZone = "";
  let storeDate = "";

  //moment.tz.guess()

  if (storeDoc && storeDoc.TimezoneIanaFormat) {
    try {
      storeZone = (storeDoc.TimezoneIanaFormat || "").trim();
      if (!moment.tz.zone(storeZone))
        throw new Error(storeZone + " is an invalid time zone.");
      else {
        storeDate = moment.tz(storeLocDate, storeZone).format();
        storeLocDate = moment(storeDate);
      }
    }
    catch (e) {
      logger.log(
        "error",
        e.message,
        "getCurrentStoreDateTime",
        logger.LogType.Error
      );
    }
  }

  return storeLocDate;
}